<template>
  <button
    type="button"
    class="mom-row-action"
    :class="{ 'mom-row-action--danger': danger }"
    :aria-label="label"
    :title="label"
  >
    <feather-icon
      :icon="icon"
      size="18"
    />
  </button>
</template>

<script>
export default {
  name: 'RowAction',
  props: {
    icon: { type: String, required: true },
    label: { type: String, required: true },
    danger: Boolean,
  },
}
</script>
